/**
 * Statement rule categories and helpers (client).
 */
import {
  extractZellePayeeKey,
  isZelleDescription,
  normalizePayeeName,
  zellePayeeKeysMatch
} from './zellePayee';

export function stripVolatileTokens(text) {
  if (!text) return '';
  let s = String(text).toLowerCase();
  s = s.replace(/\b\d{1,2}[\/\-]\d{1,2}[\/\-]\d{2,4}\b/g, ' ');
  s = s.replace(/\b\d{4}-\d{2}-\d{2}\b/g, ' ');
  s = s.replace(/\b\d{1,2}[\/\-]\d{1,2}\b/g, ' ');
  s = s.replace(/\b(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])\d{2,4}\b/g, ' ');
  s = s.replace(/\b\d{10,}\b/g, ' ');
  s = s.replace(/\*\d+/g, ' ');
  s = s.replace(/\*+/g, ' ');
  s = s.replace(/\b(ref|confirmation|conf|id|trace|auth)\s*#?\s*\d+\b/gi, ' ');
  s = s.replace(/[,:;|#]+/g, ' ');
  s = s.replace(/\s+/g, ' ').trim();
  return s;
}

export function extractMatchKey(description) {
  if (!description) return '';
  if (isZelleDescription(description)) return extractZellePayeeKey(description);
  const stripped = stripVolatileTokens(description);
  const normalized = normalizePayeeName(stripped);
  const words = normalized.split(' ').filter(w => w.length >= 2 && !/^\d+$/.test(w));
  if (words.length === 0) return normalized;
  return words.slice(0, 4).join(' ');
}

export function descriptionMatchesRule(ruleKey, txDescription) {
  if (!ruleKey || !txDescription) return false;
  const a = extractMatchKey(ruleKey);
  const b = extractMatchKey(txDescription);
  if (!a || !b) return false;
  if (a === b) return true;
  if (isZelleDescription(ruleKey) || isZelleDescription(txDescription)) {
    return zellePayeeKeysMatch(ruleKey, txDescription);
  }
  // Avoid loose substring matches (e.g. "ach withdrawal" matching every ACH line)
  if (a.length >= 10 && b.length >= 10 && (a.includes(b) || b.includes(a))) return true;
  return false;
}

export const SCHEDULE_E_CATEGORIES = [
  { value: 'rental_income', label: 'Rental income (credit)' },
  { value: 'w2_income', label: 'W-2 / wages (credit)' },
  { value: 'advertising', label: 'Advertising' },
  { value: 'travel', label: 'Auto & travel' },
  { value: 'maintenance', label: 'Cleaning & maintenance' },
  { value: 'insurance', label: 'Insurance' },
  { value: 'professional_services', label: 'Legal & professional' },
  { value: 'property_management', label: 'Management fees' },
  { value: 'mortgage', label: 'Mortgage interest' },
  { value: 'other_interest', label: 'Other interest' },
  { value: 'repairs', label: 'Repairs' },
  { value: 'office_supplies', label: 'Supplies' },
  { value: 'property_taxes', label: 'Property taxes' },
  { value: 'utilities', label: 'Utilities' },
  { value: 'other', label: 'Other (Schedule E)' }
];

export const BUDGET_CATEGORIES = [
  { value: 'utilities', label: 'Utilities' },
  { value: 'groceries', label: 'Groceries' },
  { value: 'dining', label: 'Dining' },
  { value: 'travel', label: 'Travel' },
  { value: 'subscriptions', label: 'Subscriptions' },
  { value: 'maintenance', label: 'Maintenance' },
  { value: 'insurance', label: 'Insurance' },
  { value: 'other', label: 'Other personal' }
];

export const INCOME_CATEGORIES = new Set(['rental_income', 'w2_income']);

export function isIncomeCategory(category) {
  return INCOME_CATEGORIES.has(category);
}
